module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"title":"Produktinformationen","labels":{"search":"Suchen"},"table":{"headers":{"id":"ID","header1":"Titel 1","header2":"Titel 2","actions":"Aktionen"}},"buttons":{"addProductInformation":"Hinzufügen"}}}')
  delete Component.options._Ctor
}
